import { Flame } from 'lucide-react';

/**
 * "Filling fast" urgency pill: red→orange gradient, flickering flame, a light
 * sweep and a heartbeat glow. `left` is the admin-entered count ("Only 12
 * left"); without it the pill just says Filling fast. Motion collapses for
 * visitors who prefer reduced motion (see index.css).
 */
export const FillingFastBadge = ({ left = null, size = 'sm', long = false, className = '' }) => {
  const sizing = size === 'md' ? 'px-3 py-1 text-xs' : 'px-2.5 py-1 text-[11px]';
  return (
    <span
      className={`relative inline-flex items-center gap-1 overflow-hidden rounded-full bg-gradient-to-r from-red-600 via-red-500 to-orange-500 font-bold text-white shadow-sm animate-heartbeat ${sizing} ${className}`}
    >
      <Flame className="h-3.5 w-3.5 shrink-0 fill-yellow-300 text-yellow-200 animate-flicker" aria-hidden="true" />
      <span className="relative z-10 whitespace-nowrap">
        Filling fast
        {left ? (long ? ` · Only ${left} left` : ` · ${left} left`) : ''}
      </span>
      <span
        className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/45 to-transparent animate-sheen"
        aria-hidden="true"
      />
    </span>
  );
};

/** One-line nudge for book buttons / sticky bars: "🔥 Only 12 left — book now". */
export const FillingFastLine = ({ left = null, className = '' }) => (
  <p className={`flex items-center gap-1 text-xs font-bold text-red-600 ${className}`}>
    <Flame className="h-3.5 w-3.5 fill-orange-400 text-red-500 animate-flicker" aria-hidden="true" />
    {left ? `Only ${left} left — book before it's gone` : 'Filling fast — book before it sells out'}
  </p>
);

export default FillingFastBadge;
